<template>
  <div class="field invoice-form-notes">
    <div class="field-body">
      <div class="field">
        <label class="label input-wrapper">
          <span class="input-label">Memo / Notes</span>
          <textarea v-model="notes" class="textarea" placeholder="Memo / Notes"></textarea>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceFormNotes',
  props: {
    notes: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/Variables.scss';

.field.invoice-form-notes {
  flex: 1 1 100%;
  width: 100%;
  .input-wrapper {
    .input-label {
      font-size: .8125rem;
      font-weight: 700;
      left: auto;
      opacity: 1;
      position: relative;
      top: auto;
      transform: none;
      z-index: auto;
    }
    textarea {
      background: $white-widow;
      border: 0;
      border-radius: 5px;
      box-shadow: 0 0 0 1px $grey;
      display: inline-block;
      font-size: 1rem;
      height: auto;
      margin-bottom: 15px;
      min-height: 8.75em;
      padding: 1em;
      transition: padding 150ms;
      width: 100%;
      -webkit-appearance: none;
      &:focus {
        box-shadow: 0 0 0 2px $nyc-diesel;
        outline: 0;
      }
    }
  }
}

@media (min-width: 768px) {
  .field.invoice-form-notes {
    flex: 1 1 50%;
  }
}
</style>
